{
    "Formatpipeddurationdayshrsminssecs": "|4d |3h |2m |1s",
    "Formatpipeddurationhrsminssecs": "|3h |2m |1s",
    "Formatpipeddurationminssecs": "|2m |1s",
    "Formatpipeddurationsecs": "|1s",
    "NAME": "TimeFormats"
}